// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"6a422ea8","100":"099c78bc","152":"83574a1e","457":"01add86b","719":"bf896a47","737":"01b52be6","899":"8c700483","973":"15a00fd7"}[chunkId] + ".chunk.js";
};